import { useState } from 'react';
import { prefetchRoutes, assignCars } from '../../utils/assignCars';
import YSRouteMap from './YSRouteMap';
import YSOverviewMap from './YSOverviewMap';
import { YSResultWrap, AssignCard } from './YS.styles';

const YSAssignmentItem = ({ group, onShowRoute }) => (
    <AssignCard>
        <div className='driverRow'>
            <div className='driverIcon'>D</div>
            <span className='driverName'>{group.driver.name}</span>
            <button className='routeBtn' onClick={onShowRoute}>경로</button>
        </div>
        {group.riders.length > 0
            ? <ul className='riderList'>
                {group.riders.map((r, i) => (
                    <li key={i} className='riderItem'>{r.name}</li>
                ))}
            </ul>
            : <div className='noRider'>탑승자 없음</div>
        }
        {group.over && <div className='overWarning'>좌석 초과</div>}
    </AssignCard>
);

const YSResult = ({ participants, myName, onDelete, onBack }) => {
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState('');
    const [routeView, setRouteView] = useState(null);
    const [overviewType, setOverviewType] = useState(null); // 'departure' | 'return'

    const runAssign = async () => {
        if (participants.length < 2) {
            alert('2명 이상 참여해야 배정할 수 있습니다.');
            return;
        }
        const drivers = participants.filter(p => p.hasCar);
        if (drivers.length === 0) {
            alert('차량을 운행하는 참여자가 없습니다.');
            return;
        }

        setLoading(true);
        setResult(null);

        try {
            // 1) OSRM 직행 경로 조회 (1인당 2건)
            const { depRoutes, retRoutes } = await prefetchRoutes(participants, setProgress);

            // 2) 배정 계산 (즉시)
            setProgress('배정 계산 중...');
            const res = assignCars(participants, depRoutes, retRoutes);
            setResult(res);
        } catch (e) {
            alert('경로 계산에 실패했습니다.');
        }

        setLoading(false);
        setProgress('');
    };

    return (
        <YSResultWrap>
            <button className='backBtn' onClick={onBack}>내 정보</button>

            <div className='sectionTitle'>참여자 ({participants.length}명)</div>
            <div className='participantList'>
                {participants.map((p, i) => (
                    <div key={i} className='participantChip'>
                        <span>{p.name}</span>
                        <span className='timeMark'>{p.departureTime}</span>
                        {p.hasCar && <span className='carMark'>차</span>}
                        {p.name === myName &&
                            <button className='chipDel' onClick={() => onDelete(p.name)}>x</button>
                        }
                    </div>
                ))}
            </div>

            <div className='overviewBtnRow'>
                <button className='overviewBtn' onClick={() => setOverviewType('departure')}>출발 현황</button>
                <button className='overviewBtn' onClick={() => setOverviewType('return')}>도착 현황</button>
            </div>

            <button className='assignBtn' onClick={runAssign} disabled={loading}>
                {loading ? progress : '차량 배정 실행 (임시)'}
            </button>

            {result && <>
                <div className='sectionTitle'>출발 배정</div>
                <div className='assignGrid'>
                    {result.departure.groups.map((group, i) => (
                        <YSAssignmentItem key={i} group={group}
                            onShowRoute={() => setRouteView({ group, type: 'departure' })}
                        />
                    ))}
                </div>
                {result.departure.unassigned.length > 0 && <>
                    <div className='subTitle'>개별 이동</div>
                    <div className='unassignedList'>
                        {result.departure.unassigned.map((p, i) => (
                            <span key={i} className='unassignedName'>{p.name}</span>
                        ))}
                    </div>
                </>}

                <div className='sectionTitle'>귀환 배정</div>
                <div className='assignGrid'>
                    {result.returnTrip.groups.map((group, i) => (
                        <YSAssignmentItem key={i} group={group}
                            onShowRoute={() => setRouteView({ group, type: 'return' })}
                        />
                    ))}
                </div>
                {result.returnTrip.unassigned.length > 0 && <>
                    <div className='subTitle'>개별 이동</div>
                    <div className='unassignedList'>
                        {result.returnTrip.unassigned.map((p, i) => (
                            <span key={i} className='unassignedName'>{p.name}</span>
                        ))}
                    </div>
                </>}
            </>}

            {routeView &&
                <YSRouteMap
                    group={routeView.group}
                    type={routeView.type}
                    onClose={() => setRouteView(null)}
                />
            }

            {overviewType &&
                <YSOverviewMap
                    participants={participants}
                    type={overviewType}
                    onClose={() => setOverviewType(null)}
                />
            }
        </YSResultWrap>
    );
};

export default YSResult;
